export default "__VITE_ASSET__eAE4gM7A__"